/**
 * Print warn messages to console in development
 * @param {any} message - The message to print
 * @param {any[]} ...optionalParams - The optional parameters to console.warn
 */
export const debugInfo = (message?: any, ...optionalParams: any[]) => {
    if ('development' === process.env.NODE_ENV) {
        console.warn(message, ...optionalParams);
    }
};
